module.exports = __webpack_public_path__ + "img/10.41ec3569.png";